import "./blocks/listing-cat-box-slider";
import "./blocks/listing-ads-slider";
import "./blocks/pricing-table";
import "./blocks/listing-store";
import ParseCss from "./util/css/ParseCss";

// Save Style CSS within Database/File
wp.data.subscribe(function () {
	const _wp$data$select = wp.data.select("core/editor");

	if (!_wp$data$select) {
		return;
	}

	const isSavingPost = _wp$data$select.isSavingPost;
	const isAutoSavingPost = _wp$data$select.isAutosavingPost;

	if (isSavingPost() && !isAutoSavingPost()) {
		ParseCss();
	}
});